import apiUtils from '@utils/apiUtils';
import toCampaignsSearchParams from '@utils/campaignsSearchParams';
import { fetchAPI } from './apiServiceHelper';
import { apiConstants } from '../utils/constants';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    campaigns: {
        get: ({ offset = defaultGetParam.offset, limit = defaultGetParam.limit, filter }) => {
            return fetchAPI.getList(
                `${apiConstants.BASE_URL}/api/campaigns`,
                apiUtils.normalizeQueryParams({
                    ...toCampaignsSearchParams(filter),
                    limit,
                    offset,
                })
            );
        },
        /*
         * One campaign with every row its Campaign Details grids show: `offers`,
         * `includedHotels` and `excludedHotels`, none of them paged (GAP-1526, GAP-1532,
         * GAP-1529).
         */
        getOne: (campaignId) =>
            fetchAPI.get(`${apiConstants.BASE_URL}/api/campaigns/${campaignId}`),
        /*
         * Creates a campaign and returns it with its `id` (GAP-1468). A broken rule is a 400 whose
         * `details` name the field each message is about.
         */
        create: (body) => fetchAPI.post(`${apiConstants.BASE_URL}/api/campaigns`, body),
        /*
         * Saves an edited campaign whole (GAP-1503): the body is the create's, and each list in it
         * replaces the saved one, so a list left out is emptied. A broken rule is a 400 as on
         * create.
         */
        update: (campaignId, body) =>
            fetchAPI.put(`${apiConstants.BASE_URL}/api/campaigns/${campaignId}`, body),
    },
    promotedProducts: {
        /*
         * Sets one included hotel's Sellable Rates and VIP Rate, which the campaign body doesn't
         * carry: the hotel is the GST id, and each rate list is saved as sent.
         */
        update: ({ campaignId, hotelId, sellableRates, vipRates }) =>
            fetchAPI.put(
                `${apiConstants.BASE_URL}/api/promoted-products?campaignId=${campaignId}&hotelId=${hotelId}`,
                { sellableRates, vipRates }
            ),
    },
};

export default api;
